var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8078 0H5.19218C2.32462 0 0 2.32462 0 5.19218V12.4985C0 15.366 2.32462 17.6906 5.19218 17.6906H19.8078C22.6754 17.6906 25 15.366 25 12.4985V5.19218C25 2.32462 22.6754 0 19.8078 0ZM16.2964 9.20079L9.46017 12.4613C9.27802 12.5481 9.06761 12.4153 9.06761 12.2135V5.48882C9.06761 5.28415 9.28355 5.15151 9.46609 5.24402L16.3023 8.70828C16.5056 8.81126 16.502 9.10275 16.2964 9.20079Z",
    fill: "#FA675C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46191 12.4611L16.2981 9.20064C16.5038 9.10259 16.5073 8.81111 16.304 8.70812L9.46782 5.24387C9.28528 5.15135 9.06934 5.284 9.06934 5.48866V12.2134C9.06934 12.4152 9.27975 12.548 9.46191 12.4611Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeOutline);
export default __webpack_public_path__ + "static/media/youtube_outline.f187783f01c1bbdeb75e2ad817378a51.svg";
export { ForwardRef as ReactComponent };